import { render } from "./OlapOutputWizard.vue?vue&type=template&id=8735a1ee&ts=true"
import script from "./OlapOutputWizard.vue?vue&type=script&lang=ts"
export * from "./OlapOutputWizard.vue?vue&type=script&lang=ts"

import "./OlapOutputWizard.vue?vue&type=style&index=0&id=8735a1ee&lang=scss"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__